import { StudentGroupConstant } from "./constant";

const studentGroupData = {
  open: false,
  data: [],
};

export const studentGroupReducer = (state = studentGroupData, action) => {
  switch (action.type) {
    case StudentGroupConstant.STUDENT_GROUP_OPEN:
      return { ...state, open: action.payload };

    case StudentGroupConstant.UPDATE_STUDENT_GROUP:
      return { ...state, ...action.payload };

    case StudentGroupConstant.SET_CLASSID_BY_DATA:
      const data = { ...state, data: action.payload };
      return data;

    case StudentGroupConstant.SET_GROUP_DATA:
      const newData = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      const d = { ...state, data: [...state.data, ...newData] };
      return d;

    case StudentGroupConstant.UPDATE_GROUP_DATA:
      const updatedData = state?.data?.map((element) => {
        if (element?.id === action.payload.id) {
          return { ...element, ...action.payload };
        }
        return element;
      });
      return { ...state, data: [...updatedData] };

    case StudentGroupConstant.DELTE_GROUP_DATA:
      const filteredData = state?.data?.filter((element) => {
        if (element.id !== action.payload) {
          return true;
        }
        return false;
      });
      const filteredTeacherData = state?.teacherData?.filter((element) => {
        if (element.id !== action.payload) {
          return true;
        }
        return false;
      });
      return { ...state, data: [...filteredData], teacherData: [...filteredTeacherData] };

    default:
      return state;
  }
};
